(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("peacetrue-js/src/core"), require("peacetrue-js/src/property-path"));
	else if(typeof define === 'function' && define.amd)
		define(["peacetrue-js/src/core", "peacetrue-js/src/property-path"], factory);
	else if(typeof exports === 'object')
		exports["Object"] = factory(require("peacetrue-js/src/core"), require("peacetrue-js/src/property-path"));
	else
		root["Peace"] = root["Peace"] || {}, root["Peace"]["Object"] = factory(root["Peace"]["Core"], root["Peace"]["PropertyPath"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__5__) {
return 